import "regenerator-runtime/runtime";
import "core-js";
import eotwJSXFactory from "base/eotwJSXFactory";
import GlobalEvents from "base/GlobalEvents";

import $ from "jquery";
import "jquery-serializejson";
import svg4everybody from "svg4everybody";
import "objectFitPolyfill";
import Page from "webPage/Page";
import {handleNavigation} from "util/navigation";
import Gallery from "webPage/Gallery";
import {handleRangeSelect} from "util/searchForm";
import {handleStickyNav} from "util/handleStickyNav";

$(function () {
    if (window.jsLoadTimeout) {
        clearTimeout(window.jsLoadTimeout);
    }

    document.documentElement.setAttribute('data-useragent', navigator.userAgent);
    if (!!window.MSInputMethodContext && !!document.documentMode) {
        $('html').addClass('ie11');
    }

    svg4everybody();

    objectFitPolyfill($('.attachment-mbhp_main_gallery_image'));

    Page.init();

    handleNavigation();
    handleRangeSelect();
    handleStickyNav();

    let $gallery = $('.js-review-track-wrap');

    if ($gallery.length > 0) {
        new Gallery($gallery, {
            itemClass:          "eotw-reviews-slider__item",
            pipClass:           "eotw-reviews-slider__pip",
            navigateClass:      "js-track-navigation",
            pipsClass:          "js-pips",
            itemsClass:         "js-items",
            itemActiveModifier: "active",
            pipActiveModifier:  "active",
            animationDuration:  200,
        });
    }
});

export function svg_include(icon, suffix = '') {
    return '<svg><use xlink:href="/wp-content/themes/avery-berkel-core/includes/svg-icons.svg?#' + icon + '"></use></svg>';
}

window.$ = window.jQuery = $;
window.eotwJSXFactory = eotwJSXFactory;
window.GlobalEvents = GlobalEvents;
